<template>
    <div v-if="serialModel.showTimer" class="text-red-600 text-center mb-3 font-main-medium" data-cy="container_serial_timer">
        <div v-if="!isTimeExpired" data-cy="text_serial_timer_active">
            {{lbl.serial.expire_in}} {{displayTime}}
        </div>
        <div v-else data-cy="text_serial_timer_expired">
            {{lbl.serial.code_expired}}
        </div>
    </div>
    <div class="border-b border-gray-1 my-1 bg-gray-1"></div>
</template>
<script>
import TimerHelper from '@/helper/TimerHelper.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "SerialTimer",
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
    },
    data: function () {
        return {
            timer: new TimerHelper(),
            displayTime: "",
            isTimeExpired: false,
        };
    },
    created: function () {
        this.initial();
    },
    beforeUnmount: function() {
        if (this.timer.interval) {
            this.timer.stopTimer();
        }
    },
    methods: {
        initial: function () {
            if (this.timer.interval) {
                this.timer.stopTimer();
            }

            this.timer.initialTimer(this.serialModel.expireIn, ":", true);
            if (this.serialModel.showTimer) {
                this.isTimeExpired = false;
                this.timer.runTimer((display) => {
                    this.displayTime = display;
                }, () => {
                    this.isTimeExpired = true;
                    this.serialExpired();
                });
            }
        },
        serialExpired: function () {
            this.$emit("onSerialExpired");
        },
    }
}
</script>
<style lang="scss" scoped>

</style>
